/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddContactDto,
  CheckContactResponseDto,
  ContactResponseDto,
  ContactsResponseDto,
  ConversationListResponseDto,
  ConversationResponseDto,
  CreateConversationDto,
  DeleteConversation200Response,
  ErrorResponse,
  MessagesResponseDto,
  UnreadCountResponseDto,
  UserPresenceResponseDto,
} from '../models/index';
import {
    AddContactDtoFromJSON,
    AddContactDtoToJSON,
    CheckContactResponseDtoFromJSON,
    CheckContactResponseDtoToJSON,
    ContactResponseDtoFromJSON,
    ContactResponseDtoToJSON,
    ContactsResponseDtoFromJSON,
    ContactsResponseDtoToJSON,
    ConversationListResponseDtoFromJSON,
    ConversationListResponseDtoToJSON,
    ConversationResponseDtoFromJSON,
    ConversationResponseDtoToJSON,
    CreateConversationDtoFromJSON,
    CreateConversationDtoToJSON,
    DeleteConversation200ResponseFromJSON,
    DeleteConversation200ResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    MessagesResponseDtoFromJSON,
    MessagesResponseDtoToJSON,
    UnreadCountResponseDtoFromJSON,
    UnreadCountResponseDtoToJSON,
    UserPresenceResponseDtoFromJSON,
    UserPresenceResponseDtoToJSON,
} from '../models/index';

export interface AddContactRequest {
    addContactDto: AddContactDto;
}

export interface CheckContactRequest {
    contactId: string;
    contactType: CheckContactContactTypeEnum;
}

export interface CreateConversationRequest {
    createConversationDto: CreateConversationDto;
}

export interface DeleteContactRequest {
    addContactDto: AddContactDto;
}

export interface DeleteConversationRequest {
    id: string;
}

export interface GetContactsRequest {
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface GetConversationRequest {
    id: string;
}

export interface GetConversationsRequest {
    page?: number;
    pageSize?: number;
    search?: string;
}

export interface GetMessagesRequest {
    id: string;
    page?: number;
    pageSize?: number;
}

export interface GetUnreadCountRequest {
    id: string;
}

export interface GetUserPresenceRequest {
    userId: string;
}

export interface MarkConversationReadRequest {
    id: string;
}

/**
 * 
 */
export class ChatApi extends runtime.BaseAPI {

    /**
     * Add a patient or provider to the current user\'s contact list
     * Add a contact to user\'s contact list
     */
    async addContactRaw(requestParameters: AddContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactResponseDto>> {
        if (requestParameters['addContactDto'] == null) {
            throw new runtime.RequiredError(
                'addContactDto',
                'Required parameter "addContactDto" was null or undefined when calling addContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/contacts`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddContactDtoToJSON(requestParameters['addContactDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactResponseDtoFromJSON(jsonValue));
    }

    /**
     * Add a patient or provider to the current user\'s contact list
     * Add a contact to user\'s contact list
     */
    async addContact(requestParameters: AddContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactResponseDto> {
        const response = await this.addContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Check if a patient or provider is already in the user\'s contact list
     * Check if contact exists in user\'s contact list
     */
    async checkContactRaw(requestParameters: CheckContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckContactResponseDto>> {
        if (requestParameters['contactId'] == null) {
            throw new runtime.RequiredError(
                'contactId',
                'Required parameter "contactId" was null or undefined when calling checkContact().'
            );
        }

        if (requestParameters['contactType'] == null) {
            throw new runtime.RequiredError(
                'contactType',
                'Required parameter "contactType" was null or undefined when calling checkContact().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['contactId'] != null) {
            queryParameters['contactId'] = requestParameters['contactId'];
        }

        if (requestParameters['contactType'] != null) {
            queryParameters['contactType'] = requestParameters['contactType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/contacts/check`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckContactResponseDtoFromJSON(jsonValue));
    }

    /**
     * Check if a patient or provider is already in the user\'s contact list
     * Check if contact exists in user\'s contact list
     */
    async checkContact(requestParameters: CheckContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckContactResponseDto> {
        const response = await this.checkContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new conversation between a patient and practice, or returns existing one if it already exists
     * Create or get conversation between patient and practice
     */
    async createConversationRaw(requestParameters: CreateConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConversationResponseDto>> {
        if (requestParameters['createConversationDto'] == null) {
            throw new runtime.RequiredError(
                'createConversationDto',
                'Required parameter "createConversationDto" was null or undefined when calling createConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/conversations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateConversationDtoToJSON(requestParameters['createConversationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new conversation between a patient and practice, or returns existing one if it already exists
     * Create or get conversation between patient and practice
     */
    async createConversation(requestParameters: CreateConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConversationResponseDto> {
        const response = await this.createConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a patient or provider from the user\'s contact list
     * Delete a contact from user\'s contact list
     */
    async deleteContactRaw(requestParameters: DeleteContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteConversation200Response>> {
        if (requestParameters['addContactDto'] == null) {
            throw new runtime.RequiredError(
                'addContactDto',
                'Required parameter "addContactDto" was null or undefined when calling deleteContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/contacts`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: AddContactDtoToJSON(requestParameters['addContactDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteConversation200ResponseFromJSON(jsonValue));
    }

    /**
     * Remove a patient or provider from the user\'s contact list
     * Delete a contact from user\'s contact list
     */
    async deleteContact(requestParameters: DeleteContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteConversation200Response> {
        const response = await this.deleteContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft deletes a conversation for the current user. The conversation will be hidden from the user\'s conversation list but will remain accessible to the other participant. If both users delete the conversation, it will be permanently deleted along with all messages.
     * Delete a conversation (soft delete)
     */
    async deleteConversationRaw(requestParameters: DeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteConversation200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/conversations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteConversation200ResponseFromJSON(jsonValue));
    }

    /**
     * Soft deletes a conversation for the current user. The conversation will be hidden from the user\'s conversation list but will remain accessible to the other participant. If both users delete the conversation, it will be permanently deleted along with all messages.
     * Delete a conversation (soft delete)
     */
    async deleteConversation(requestParameters: DeleteConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteConversation200Response> {
        const response = await this.deleteConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated list of contacts for the authenticated user
     * Get user\'s contact list
     */
    async getContactsRaw(requestParameters: GetContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContactsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/contacts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContactsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns paginated list of contacts for the authenticated user
     * Get user\'s contact list
     */
    async getContacts(requestParameters: GetContactsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContactsResponseDto> {
        const response = await this.getContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns conversation details with patient and practice info
     * Get conversation by ID
     */
    async getConversationRaw(requestParameters: GetConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConversationResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/conversations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns conversation details with patient and practice info
     * Get conversation by ID
     */
    async getConversation(requestParameters: GetConversationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConversationResponseDto> {
        const response = await this.getConversationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all conversations for the authenticated user (patient or practice)
     * Get all conversations for current user
     */
    async getConversationsRaw(requestParameters: GetConversationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConversationListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/conversations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConversationListResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns all conversations for the authenticated user (patient or practice)
     * Get all conversations for current user
     */
    async getConversations(requestParameters: GetConversationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConversationListResponseDto> {
        const response = await this.getConversationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns paginated list of messages in a conversation
     * Get messages for a conversation
     */
    async getMessagesRaw(requestParameters: GetMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessagesResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/conversations/{id}/messages`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessagesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns paginated list of messages in a conversation
     * Get messages for a conversation
     */
    async getMessages(requestParameters: GetMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessagesResponseDto> {
        const response = await this.getMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns unread message count for a conversation
     * Get unread message count for a conversation
     */
    async getUnreadCountRaw(requestParameters: GetUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnreadCountResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getUnreadCount().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/conversations/{id}/unread-count`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnreadCountResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns unread message count for a conversation
     * Get unread message count for a conversation
     */
    async getUnreadCount(requestParameters: GetUnreadCountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnreadCountResponseDto> {
        const response = await this.getUnreadCountRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns online/offline status and last seen for a user
     * Get user presence status
     */
    async getUserPresenceRaw(requestParameters: GetUserPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserPresenceResponseDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserPresence().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/presence/{userId}`.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserPresenceResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns online/offline status and last seen for a user
     * Get user presence status
     */
    async getUserPresence(requestParameters: GetUserPresenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserPresenceResponseDto> {
        const response = await this.getUserPresenceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Marks all unread messages in the conversation as read for the current user
     * Mark all messages in conversation as read
     */
    async markConversationReadRaw(requestParameters: MarkConversationReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteConversation200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling markConversationRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/conversations/{id}/read`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteConversation200ResponseFromJSON(jsonValue));
    }

    /**
     * Marks all unread messages in the conversation as read for the current user
     * Mark all messages in conversation as read
     */
    async markConversationRead(requestParameters: MarkConversationReadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteConversation200Response> {
        const response = await this.markConversationReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CheckContactContactTypeEnum = {
    Patient: 'patient',
    Provider: 'provider'
} as const;
export type CheckContactContactTypeEnum = typeof CheckContactContactTypeEnum[keyof typeof CheckContactContactTypeEnum];
